import React, { useState } from 'react';
import { Users, FileText, Map, ShoppingCart } from 'lucide-react';
import { T, glass, useIsMobile } from '../ui';
import { useGasData } from './gasData';
import type { GasView } from '../types';
import { Clientes } from './clientes';
import { Contratos } from './Contratos';
import { Rutas } from './Rutas';
import { Ventas } from './Ventas';
const NAV: {
  id: GasView;
  label: string;
  icon: React.ElementType;
}[] = [{
  id: 'clientes',
  label: 'Clientes',
  icon: Users
}, {
  id: 'contratos',
  label: 'Contratos',
  icon: FileText
}, {
  id: 'rutas',
  label: 'Rutas',
  icon: Map
}, {
  id: 'ventas',
  label: 'Ventas',
  icon: ShoppingCart
}];
export default function GasApp() {
  const isMobile = useIsMobile();
  const [view, setView] = useState<GasView>('clientes');
  const data = useGasData();
  const pages: Record<GasView, React.ReactNode> = {
    clientes: <Clientes clientes={data.clientes} onAddCliente={data.onAddCliente} onDeleteCliente={data.onDeleteCliente} onUpdateCliente={data.onUpdateCliente} data-id="element-558" />,
    contratos: <Contratos contratos={data.contratos} clientes={data.clientes} onAddContrato={data.onAddContrato} onDeleteContrato={data.onDeleteContrato} onUpdateContrato={data.onUpdateContrato} data-id="element-559" />,
    rutas: <Rutas rutas={data.rutas} clientes={data.clientes} onAddRuta={data.onAddRuta} onDeleteRuta={data.onDeleteRuta} onUpdateRuta={data.onUpdateRuta} data-id="element-560" />,
    ventas: <Ventas ventas={data.ventas} clientes={data.clientes} onAddVenta={data.onAddVenta} onDeleteVenta={data.onDeleteVenta} onUpdateVenta={data.onUpdateVenta} data-id="element-561" />
  };
  return <div style={{
    minHeight: '100vh',
    background: '#FFFCF8',
    color: '#1A1207'
  }} data-id="element-562">
      <header style={{
      ...glass,
      position: 'sticky',
      top: 0,
      zIndex: 100,
      borderRadius: 0,
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
      padding: isMobile ? '10px 14px' : '14px 24px',
      display: 'flex',
      alignItems: 'center',
      gap: isMobile ? 8 : 6,
      flexWrap: 'wrap'
    }} data-id="element-563">
        <div style={{
        fontWeight: 800,
        fontSize: 15,
        marginRight: isMobile ? 0 : 20,
        flexShrink: 0
      }} data-id="element-564">
          Gas Industrial
        </div>
        <nav style={{
        display: 'flex',
        gap: 4,
        overflowX: isMobile ? 'auto' : 'visible',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-565">
          {NAV.map(item => {
          const Icon = item.icon;
          const active = view === item.id;
          return <button key={item.id} onClick={() => setView(item.id)} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '7px 12px',
            borderRadius: 10,
            border: 'none',
            background: active ? 'rgba(255,107,1,.12)' : 'transparent',
            color: active ? T.accent : T.textMuted,
            fontSize: 12.5,
            fontWeight: active ? 700 : 600,
            whiteSpace: 'nowrap',
            flexShrink: 0
          }} data-id="element-566">
                <Icon size={15} data-id="element-567" />
                {item.label}
              </button>;
        })}
        </nav>
      </header>
      <main style={{
      padding: isMobile ? '18px 14px 48px' : '28px 24px 60px',
      maxWidth: 1200,
      margin: '0 auto'
    }} data-id="element-568">
        {pages[view]}
      </main>
    </div>;
}